import React, { Component } from "react";
import {
  Heading,
  Main,
  Grid,
  Button,
  TextInput,
  Select,
  CheckBox,
  Text
} from "grommet";

import {
  owmGetData,
  saveData,
  getWindDirection,
  dayOfWeek,
  dayOfWeekShort,
  getATVjson,
  getWindSpeed
} from "./data/weather";

import { icons, days, daysShort, wind, windSpeed, warning } from "./data/icons";

import Belgie from "./Belgie";

class ATV extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        vannachtTemp: "",
        vannachtIcon: "",
        vannachtWind: "",
        vannachtWindText: "",
        vannachtSub: "",
        vannachtWarning: false,
        vannachtWarningIcon: "",
        provincieTitle: "",
        provincieTemp: "",
        provincieIcon: "",
        provincieWind: "",
        provincieWindText: "",
        provincieSub: "",
        provincieWarning: false,
        provincieWarningIcon: "",
        belgieTitle: "",
        belgieSub: "",
        belgieTemp1: "",
        belgieIcon1: "",
        belgieTemp2: "",
        belgieIcon2: "",
        belgieTemp3: "",
        belgieIcon3: "",
        belgieTemp4: "",
        belgieIcon4: "",
        belgieTemp5: "",
        belgieIcon5: "",
        belgieTemp6: "",
        belgieIcon6: "",
        belgieWind: "",
        belgieWindText: "",
        belgieWind2: "",
        belgieWindText2: "",
        overzichtTitle1: "",
        overzichtIcon1: "",
        overzichtTempMax1: "",
        overzichtTempMin1: "",
        overzichtWindIcon1: "",
        overzichtWindText1: "",
        overzichtTitle2: "",
        overzichtIcon2: "",
        overzichtTempMax2: "",
        overzichtTempMin2: "",
        overzichtWindIcon2: "",
        overzichtWindText2: "",
        overzichtTitle3: "",
        overzichtIcon3: "",
        overzichtTempMax3: "",
        overzichtTempMin3: "",
        overzichtWindIcon3: "",
        overzichtWindText3: "",
        overzichtTitle4: "",
        overzichtIcon4: "",
        overzichtTempMax4: "",
        overzichtTempMin4: "",
        overzichtWindIcon4: "",
        overzichtWindText4: "",
        overzichtTitle5: "",
        overzichtIcon5: "",
        overzichtTempMax5: "",
        overzichtTempMin5: "",
        overzichtWindIcon5: "",
        overzichtWindText5: "",
        overzichtTitle6: "",
        overzichtIcon6: "",
        overzichtTempMax6: "",
        overzichtTempMin6: "",
        overzichtWindIcon6: "",
        overzichtWindText6: "",
        samenvatting: "",
        lastSaved: ""
      }
    };
    this.getData = this.getData.bind(this);
    this.saveDataClick = this.saveDataClick.bind(this);
  }

  componentDidMount() {
    getATVjson().then(data => {
      this.setState({
        data: {
          vannachtTemp: data.vannacht.temp,
          vannachtIcon: data.vannacht.icon,
          vannachtWind: data.vannacht.wind,
          vannachtWindText: data.vannacht.windText,
          vannachtSub: data.vannacht.sub,
          vannachtWarning: data.vannacht.warning,
          vannachtWarningIcon: data.vannacht.warningIcon,
          provincieTitle: data.dagProvincie.title,
          provincieTemp: data.dagProvincie.temp,
          provincieIcon: data.dagProvincie.icon,
          provincieWind: data.dagProvincie.wind,
          provincieWindText: data.dagProvincie.windText,
          provincieSub: data.dagProvincie.sub,
          provincieWarning: data.dagProvincie.warning,
          provincieWarningIcon: data.dagProvincie.warningIcon,
          belgieTitle: data.dagBelgie.title,
          belgieSub: data.dagBelgie.sub,
          belgieTemp1: data.dagBelgie.temp1.temp,
          belgieIcon1: data.dagBelgie.temp1.icon,
          belgieTemp2: data.dagBelgie.temp2.temp,
          belgieIcon2: data.dagBelgie.temp2.icon,
          belgieTemp3: data.dagBelgie.temp3.temp,
          belgieIcon3: data.dagBelgie.temp3.icon,
          belgieTemp4: data.dagBelgie.temp4.temp,
          belgieIcon4: data.dagBelgie.temp4.icon,
          belgieTemp5: data.dagBelgie.temp5.temp,
          belgieIcon5: data.dagBelgie.temp5.icon,
          belgieTemp6: data.dagBelgie.temp6.temp,
          belgieIcon6: data.dagBelgie.temp6.icon,
          belgieWind: data.dagBelgie.wind,
          belgieWindText: data.dagBelgie.windText,
          belgieWind2: data.dagBelgie.wind2,
          belgieWindText2: data.dagBelgie.windText2,
          overzichtTitle1: data.overzicht.temp1.title,
          overzichtIcon1: data.overzicht.temp1.icon,
          overzichtTempMax1: data.overzicht.temp1.tempMax,
          overzichtTempMin1: data.overzicht.temp1.tempMin,
          overzichtWindIcon1: data.overzicht.temp1.windIcon,
          overzichtWindText1: data.overzicht.temp1.windText,
          overzichtTitle2: data.overzicht.temp2.title,
          overzichtIcon2: data.overzicht.temp2.icon,
          overzichtTempMax2: data.overzicht.temp2.tempMax,
          overzichtTempMin2: data.overzicht.temp2.tempMin,
          overzichtWindIcon2: data.overzicht.temp2.windIcon,
          overzichtWindText2: data.overzicht.temp2.windText,
          overzichtTitle3: data.overzicht.temp3.title,
          overzichtIcon3: data.overzicht.temp3.icon,
          overzichtTempMax3: data.overzicht.temp3.tempMax,
          overzichtTempMin3: data.overzicht.temp3.tempMin,
          overzichtWindIcon3: data.overzicht.temp3.windIcon,
          overzichtWindText3: data.overzicht.temp3.windText,
          overzichtTitle4: data.overzicht.temp4.title,
          overzichtIcon4: data.overzicht.temp4.icon,
          overzichtTempMax4: data.overzicht.temp4.tempMax,
          overzichtTempMin4: data.overzicht.temp4.tempMin,
          overzichtWindIcon4: data.overzicht.temp4.windIcon,
          overzichtWindText4: data.overzicht.temp4.windText,
          overzichtTitle5: data.overzicht.temp5.title,
          overzichtIcon5: data.overzicht.temp5.icon,
          overzichtTempMax5: data.overzicht.temp5.tempMax,
          overzichtTempMin5: data.overzicht.temp5.tempMin,
          overzichtWindIcon5: data.overzicht.temp5.windIcon,
          overzichtWindText5: data.overzicht.temp5.windText,
          overzichtTitle6: data.overzicht.temp6.title,
          overzichtIcon6: data.overzicht.temp6.icon,
          overzichtTempMax6: data.overzicht.temp6.tempMax,
          overzichtTempMin6: data.overzicht.temp6.tempMin,
          overzichtWindIcon6: data.overzicht.temp6.windIcon,
          overzichtWindText6: data.overzicht.temp6.windText,
          samenvatting: data.samenvatting.text,
          lastSaved: data.lastSaved
        }
      });
    });
  }

  getData() {
    owmGetData("51.2603015", "4.2176376").then(owm => {
      const { data } = { ...this.state };
      const currentState = data;
      currentState.vannachtTemp = Math.round(owm.daily[0].temp.night);
      currentState.vannachtIcon = owm.daily[0].weather[0];
      currentState.vannachtWind = getWindDirection(owm.daily[0].wind_deg);
      currentState.vannachtWindText = getWindSpeed(owm.daily[0].wind_speed);
      currentState.provincieTemp = Math.round(owm.daily[1].temp.day);
      currentState.provincieIcon = owm.daily[1].weather[0];
      currentState.provincieWind = getWindDirection(owm.daily[1].wind_deg);
      currentState.provincieWindText = getWindSpeed(owm.daily[1].wind_speed);
      currentState.overzichtIcon1 = owm.daily[1].weather[0];
      currentState.overzichtTempMax1 = Math.round(owm.daily[1].temp.max);
      currentState.overzichtTempMin1 = Math.round(owm.daily[1].temp.min);
      currentState.overzichtWindIcon1 = getWindDirection(owm.daily[1].wind_deg);
      currentState.overzichtWindText1 = getWindSpeed(owm.daily[1].wind_speed);
      currentState.overzichtIcon2 = owm.daily[2].weather[0];
      currentState.overzichtTempMax2 = Math.round(owm.daily[2].temp.max);
      currentState.overzichtTempMin2 = Math.round(owm.daily[2].temp.min);
      currentState.overzichtWindIcon2 = getWindDirection(owm.daily[2].wind_deg);
      currentState.overzichtWindText2 = getWindSpeed(owm.daily[2].wind_speed);
      currentState.overzichtIcon3 = owm.daily[3].weather[0];
      currentState.overzichtTempMax3 = Math.round(owm.daily[3].temp.max);
      currentState.overzichtTempMin3 = Math.round(owm.daily[3].temp.min);
      currentState.overzichtWindIcon3 = getWindDirection(owm.daily[3].wind_deg);
      currentState.overzichtWindText3 = getWindSpeed(owm.daily[3].wind_speed);
      currentState.overzichtIcon4 = owm.daily[4].weather[0];
      currentState.overzichtTempMax4 = Math.round(owm.daily[4].temp.max);
      currentState.overzichtTempMin4 = Math.round(owm.daily[4].temp.min);
      currentState.overzichtWindIcon4 = getWindDirection(owm.daily[4].wind_deg);
      currentState.overzichtWindText4 = getWindSpeed(owm.daily[4].wind_speed);
      currentState.overzichtIcon5 = owm.daily[5].weather[0];
      currentState.overzichtTempMax5 = Math.round(owm.daily[5].temp.max);
      currentState.overzichtTempMin5 = Math.round(owm.daily[5].temp.min);
      currentState.overzichtWindIcon5 = getWindDirection(owm.daily[5].wind_deg);
      currentState.overzichtWindText5 = getWindSpeed(owm.daily[5].wind_speed);
      currentState.overzichtIcon6 = owm.daily[6].weather[0];
      currentState.overzichtTempMax6 = Math.round(owm.daily[6].temp.max);
      currentState.overzichtTempMin6 = Math.round(owm.daily[6].temp.min);
      currentState.overzichtWindIcon6 = getWindDirection(owm.daily[6].wind_deg);
      currentState.overzichtWindText6 = getWindSpeed(owm.daily[6].wind_speed);

      this.setState({
        data: currentState
      });
    });

    //Kust
    owmGetData("51.125584", "2.553720").then(owm => {
      const { data } = { ...this.state };
      const currentState = data;
      currentState.belgieTemp1 = Math.round(owm.daily[1].temp.day);
      currentState.belgieIcon1 = owm.daily[1].weather[0];
      currentState.belgieWind2 = getWindDirection(owm.daily[1].wind_deg);
      currentState.belgieWindText2 = getWindSpeed(owm.daily[1].wind_speed);

      this.setState({
        data: currentState
      });
    });

    //Oost Vlaanderen
    owmGetData("51.0734547", "3.687112").then(owm => {
      const { data } = { ...this.state };
      const currentState = data;
      currentState.belgieTemp2 = Math.round(owm.daily[1].temp.day);
      currentState.belgieIcon2 = owm.daily[1].weather[0];

      this.setState({
        data: currentState
      });
    });

    //Antwerpen
    owmGetData("51.2603015", "4.2176376").then(owm => {
      const { data } = { ...this.state };
      const currentState = data;
      currentState.belgieTemp3 = Math.round(owm.daily[1].temp.day);
      currentState.belgieIcon3 = owm.daily[1].weather[0];

      this.setState({
        data: currentState
      });
    });

    //Brussel
    owmGetData("50.8477584", "4.3641418").then(owm => {
      const { data } = { ...this.state };
      const currentState = data;
      currentState.belgieTemp4 = Math.round(owm.daily[1].temp.day);
      currentState.belgieIcon4 = owm.daily[1].weather[0];
      currentState.belgieWind = getWindDirection(owm.daily[1].wind_deg);
      currentState.belgieWindText = getWindSpeed(owm.daily[1].wind_speed);

      this.setState({
        data: currentState
      });
    });

    //Limburg
    owmGetData("50.9245441", "5.243426").then(owm => {
      const { data } = { ...this.state };
      const currentState = data;
      currentState.belgieTemp5 = Math.round(owm.daily[1].temp.day);
      currentState.belgieIcon5 = owm.daily[1].weather[0];

      this.setState({
        data: currentState
      });
    });

    //Ardennen
    owmGetData("50.1395935", "5.2603147").then(owm => {
      const { data } = { ...this.state };
      const currentState = data;
      currentState.belgieTemp6 = Math.round(owm.daily[1].temp.day);
      currentState.belgieIcon6 = owm.daily[1].weather[0];

      this.setState({
        data: currentState
      });
    });

    var d = new Date();
    var n = d.getDay();
    const { data } = { ...this.state };
    const currentState = data;

    currentState.provincieTitle = dayOfWeek(n + 1);
    currentState.belgieTitle = dayOfWeek(n + 1);
    currentState.overzichtTitle1 = dayOfWeekShort(n + 1);
    currentState.overzichtTitle2 = dayOfWeekShort(n + 2);
    currentState.overzichtTitle3 = dayOfWeekShort(n + 3);
    currentState.overzichtTitle4 = dayOfWeekShort(n + 4);
    currentState.overzichtTitle5 = dayOfWeekShort(n + 5);
    currentState.overzichtTitle6 = dayOfWeekShort(n + 6);
    currentState.vannachtWarning = false;
    currentState.vannachtWarningIcon = "";
    currentState.provincieWarning = false;
    currentState.provincieWarningIcon = "";

    this.setState({
      data: currentState
    });
  }

  saveDataClick() {
    var d = new Date();
    const { data } = { ...this.state };
    const currentState = data;
    currentState.lastSaved = d.toString();

    this.setState({ data: currentState }, () => {
      var data = {
        vannacht: {
          temp: this.state.data.vannachtTemp,
          icon: this.state.data.vannachtIcon,
          wind: this.state.data.vannachtWind,
          windText: this.state.data.vannachtWindText,
          sub: this.state.data.vannachtSub,
          warning: this.state.data.vannachtWarning,
          warningIcon: this.state.data.vannachtWarningIcon
        },
        dagProvincie: {
          title: this.state.data.provincieTitle,
          temp: this.state.data.provincieTemp,
          icon: this.state.data.provincieIcon,
          wind: this.state.data.provincieWind,
          windText: this.state.data.provincieWindText,
          sub: this.state.data.provincieSub,
          warning: this.state.data.provincieWarning,
          warningIcon: this.state.data.provincieWarningIcon
        },
        dagBelgie: {
          title: this.state.data.belgieTitle,
          sub: this.state.data.belgieSub,
          temp1: {
            temp: this.state.data.belgieTemp1,
            icon: this.state.data.belgieIcon1
          },
          temp2: {
            temp: this.state.data.belgieTemp2,
            icon: this.state.data.belgieIcon2
          },
          temp3: {
            temp: this.state.data.belgieTemp3,
            icon: this.state.data.belgieIcon3
          },
          temp4: {
            temp: this.state.data.belgieTemp4,
            icon: this.state.data.belgieIcon4
          },
          temp5: {
            temp: this.state.data.belgieTemp5,
            icon: this.state.data.belgieIcon5
          },
          temp6: {
            temp: this.state.data.belgieTemp6,
            icon: this.state.data.belgieIcon6
          },
          wind: this.state.data.belgieWind,
          windText: this.state.data.belgieWindText,
          wind2: this.state.data.belgieWind2,
          windText2: this.state.data.belgieWindText2
        },
        overzicht: {
          temp1: {
            title: this.state.data.overzichtTitle1,
            icon: this.state.data.overzichtIcon1,
            tempMax: this.state.data.overzichtTempMax1,
            tempMin: this.state.data.overzichtTempMin1,
            windIcon: this.state.data.overzichtWindIcon1,
            windText: this.state.data.overzichtWindText1
          },
          temp2: {
            title: this.state.data.overzichtTitle2,
            icon: this.state.data.overzichtIcon2,
            tempMax: this.state.data.overzichtTempMax2,
            tempMin: this.state.data.overzichtTempMin2,
            windIcon: this.state.data.overzichtWindIcon2,
            windText: this.state.data.overzichtWindText2
          },
          temp3: {
            title: this.state.data.overzichtTitle3,
            icon: this.state.data.overzichtIcon3,
            tempMax: this.state.data.overzichtTempMax3,
            tempMin: this.state.data.overzichtTempMin3,
            windIcon: this.state.data.overzichtWindIcon3,
            windText: this.state.data.overzichtWindText3
          },
          temp4: {
            title: this.state.data.overzichtTitle4,
            icon: this.state.data.overzichtIcon4,
            tempMax: this.state.data.overzichtTempMax4,
            tempMin: this.state.data.overzichtTempMin4,
            windIcon: this.state.data.overzichtWindIcon4,
            windText: this.state.data.overzichtWindText4
          },
          temp5: {
            title: this.state.data.overzichtTitle5,
            icon: this.state.data.overzichtIcon5,
            tempMax: this.state.data.overzichtTempMax5,
            tempMin: this.state.data.overzichtTempMin5,
            windIcon: this.state.data.overzichtWindIcon5,
            windText: this.state.data.overzichtWindText5
          },
          temp6: {
            title: this.state.data.overzichtTitle6,
            icon: this.state.data.overzichtIcon6,
            tempMax: this.state.data.overzichtTempMax6,
            tempMin: this.state.data.overzichtTempMin6,
            windIcon: this.state.data.overzichtWindIcon6,
            windText: this.state.data.overzichtWindText6
          }
        },
        samenvatting: {
          text: this.state.data.samenvatting
        },
        lastSaved: this.state.data.lastSaved
      };

      saveData("atv", data);
    });
  }

  handleChange = name => event => {
    const { data } = { ...this.state };
    const currentState = data;
    currentState[name] = event.target.value;

    this.setState({ data: currentState });
  };

  handleChangeCheckBox = name => event => {
    const { data } = { ...this.state };
    const currentState = data;
    currentState[name] = event.target.checked;

    this.setState({ data: currentState });
  };

  handleChangeSelect = (option, name) => {
    const { data } = { ...this.state };
    const currentState = data;
    currentState[name] = option;

    this.setState({ data: currentState });
  };

  render() {
    return (
      <Main
        fill="vertical"
        flex="grow"
        overflow="auto"
        pad="xlarge"
        justify="start"
      >
        <div className="atvHeader"></div>
        <Grid columns="small" margin="small">
          <Button label="Load data"/>
        </Grid>
        <Heading level="4">Vannacht</Heading>
        <Grid
          columns={{ size: "small", count: "fill" }}
          margin="small"
          gap="medium"
        >
          <TextInput
            placeholder="Temp"
            value={this.state.data.vannachtTemp}
            onChange={this.handleChange("vannachtTemp")}
          />
          <Select
            options={icons}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Icon"
            labelKey="description"
            valueKey="id"
            value={this.state.data.vannachtIcon}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "vannachtIcon")
            }
          />

          <Select
            options={wind}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Wind"
            value={this.state.data.vannachtWind}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "vannachtWind")
            }
          />
          <Select
            options={windSpeed}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Wind Speed"
            value={this.state.data.vannachtWindText}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "vannachtWindText")
            }
          />
        </Grid>
        <Grid
          columns={{ size: "small", count: "fill" }}
          margin="small"
          gap="medium"
        >
          <CheckBox
            label="Warning Icon"
            checked={this.state.data.vannachtWarning}
            onChange={this.handleChangeCheckBox("vannachtWarning")}
          />
          <Select
            options={warning}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Warning"
            value={this.state.data.vannachtWarningIcon}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "vannachtWarningIcon")
            }
          />
        </Grid>
        <Grid
          columns={{ size: "small", count: "fill" }}
          margin="small"
          gap="medium"
        >
          <TextInput
            placeholder="Subtitle"
            value={this.state.data.vannachtSub}
            onChange={this.handleChange("vannachtSub")}
          />
        </Grid>

        <Heading level="4" size="xlarge">
          Dag Provincie
        </Heading>
        <Grid
          columns={{ size: "small", count: "fill" }}
          margin="small"
          gap="medium"
        >
          <Select
            options={days}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="dag"
            value={this.state.data.provincieTitle}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "provincieTitle")
            }
          />
        </Grid>
        <Grid
          columns={{ size: "small", count: "fill" }}
          margin="small"
          gap="medium"
        >
          <TextInput
            placeholder="Temp"
            value={this.state.data.provincieTemp}
            onChange={this.handleChange("provincieTemp")}
          />
          <Select
            options={icons}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Icon"
            labelKey="description"
            valueKey="id"
            value={this.state.data.provincieIcon}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "provincieIcon")
            }
          />
          <Select
            options={wind}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Wind"
            value={this.state.data.provincieWind}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "provincieWind")
            }
          />
          <Select
            options={windSpeed}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Wind Speed"
            value={this.state.data.provincieWindText}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "provincieWindText")
            }
          />
        </Grid>
        <Grid
          columns={{ size: "small", count: "fill" }}
          margin="small"
          gap="medium"
        >
          <CheckBox
            label="Warning Icon"
            checked={this.state.data.provincieWarning}
            onChange={this.handleChangeCheckBox("provincieWarning")}
          />
          <Select
            options={warning}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Warning"
            value={this.state.data.provincieWarningIcon}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "provincieWarningIcon")
            }
          />
        </Grid>
        <Grid
          columns={{ size: "small", count: "fill" }}
          margin="small"
          gap="medium"
        >
          <TextInput
            placeholder="Subtitle"
            value={this.state.data.provincieSub}
            onChange={this.handleChange("provincieSub")}
          />
        </Grid>
        <Heading level="4">Dag België</Heading>
        <Grid
          columns={{ size: "small", count: "fill" }}
          margin="small"
          gap="medium"
        >
          <Select
            options={days}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="dag"
            value={this.state.data.belgieTitle}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "belgieTitle")
            }
          />
        </Grid>
        <Grid
          columns={{ size: "small", count: "fill" }}
          margin="small"
          gap="medium"
        >
          <TextInput
            placeholder="Subtitle"
            value={this.state.data.belgieSub}
            onChange={this.handleChange("belgieSub")}
          />
        </Grid>
        <Grid
          columns={{ size: "small", count: "fill" }}
          margin="small"
          gap="medium"
          alignContent="center"
          align="center"
        >
          <Text textAlign="start">Kust</Text>
          <TextInput
            placeholder="Temp"
            value={this.state.data.belgieTemp1}
            onChange={this.handleChange("belgieTemp1")}
          />
          <Select
            options={icons}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Icon"
            labelKey="description"
            valueKey="id"
            value={this.state.data.belgieIcon1}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "belgieIcon1")
            }
          />
        </Grid>
        <Grid
          columns={{ size: "small", count: "fill" }}
          margin="small"
          gap="medium"
          alignContent="center"
          align="center"
        >
          <Text textAlign="start">Antwerpen</Text>
          <TextInput
            placeholder="Temp"
            value={this.state.data.belgieTemp2}
            onChange={this.handleChange("belgieTemp2")}
          />
          <Select
            options={icons}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Icon"
            labelKey="description"
            valueKey="id"
            value={this.state.data.belgieIcon2}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "belgieIcon2")
            }
          />
        </Grid>
        <Grid
          columns={{ size: "small", count: "fill" }}
          margin="small"
          gap="medium"
          alignContent="center"
          align="center"
        >
          <Text textAlign="start">Brussel</Text>
          <TextInput
            placeholder="Temp"
            value={this.state.data.belgieTemp3}
            onChange={this.handleChange("belgieTemp3")}
          />
          <Select
            options={icons}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Icon"
            labelKey="description"
            valueKey="id"
            value={this.state.data.belgieIcon3}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "belgieIcon3")
            }
          />
        </Grid>
        <Grid
          columns={{ size: "small", count: "fill" }}
          margin="small"
          gap="medium"
          alignContent="center"
          align="center"
        >
          <Text textAlign="start">Mont Rigi</Text>
          <TextInput
            placeholder="Temp"
            value={this.state.data.belgieTemp4}
            onChange={this.handleChange("belgieTemp4")}
          />
          <Select
            options={icons}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Icon"
            labelKey="description"
            valueKey="id"
            value={this.state.data.belgieIcon4}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "belgieIcon4")
            }
          />
        </Grid>
        <Grid
          columns={{ size: "small", count: "fill" }}
          margin="small"
          gap="medium"
          alignContent="center"
          align="center"
        >
          <Text textAlign="start">Neufchateau</Text>
          <TextInput
            placeholder="Temp"
            value={this.state.data.belgieTemp5}
            onChange={this.handleChange("belgieTemp5")}
          />
          <Select
            options={icons}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Icon"
            labelKey="description"
            valueKey="id"
            value={this.state.data.belgieIcon5}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "belgieIcon5")
            }
          />
        </Grid>
        <Grid
          columns={{ size: "small", count: "fill" }}
          margin="small"
          gap="medium"
        >
          <Select
            options={wind}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Wind"
            value={this.state.data.belgieWind}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "belgieWind")
            }
          />
          <Select
            options={windSpeed}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Wind Kust Text"
            value={this.state.data.belgieWindText}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "belgieWindText")
            }
          />
        </Grid>
        <Grid
          columns={{ size: "small", count: "fill" }}
          margin="small"
          gap="medium"
        >
          <Select
            options={wind}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Wind Kust"
            value={this.state.data.belgieWind2}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "belgieWind2")
            }
          />
          <Select
            options={windSpeed}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Wind Kust Text"
            value={this.state.data.belgieWindText2}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "belgieWindText2")
            }
          />
        </Grid>
        <Heading level="4">Overzicht</Heading>
        <Grid columns="xsmall" gap="medium" rows="xxsmall">
          <Select
            options={daysShort}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="dag"
            value={this.state.data.overzichtTitle1}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "overzichtTitle1")
            }
          />
          <Select
            options={icons}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Icon"
            labelKey="description"
            valueKey="id"
            value={this.state.data.overzichtIcon1}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "overzichtIcon1")
            }
          />
          <TextInput
            placeholder="° max"
            value={this.state.data.overzichtTempMax1}
            onChange={this.handleChange("overzichtTempMax1")}
          />
          <TextInput
            placeholder="° min"
            value={this.state.data.overzichtTempMin1}
            onChange={this.handleChange("overzichtTempMin1")}
          />
          <Select
            options={wind}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Wind"
            value={this.state.data.overzichtWindIcon1}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "overzichtWindIcon1")
            }
          />
          <Select
            options={windSpeed}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Wind Speed"
            value={this.state.data.overzichtWindText1}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "overzichtWindText1")
            }
          />
        </Grid>
        <Grid columns="xsmall" gap="medium" rows="xxsmall">
          <Select
            options={daysShort}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="dag"
            value={this.state.data.overzichtTitle2}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "overzichtTitle2")
            }
          />
          <Select
            options={icons}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Icon"
            labelKey="description"
            valueKey="id"
            value={this.state.data.overzichtIcon2}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "overzichtIcon2")
            }
          />
          <TextInput
            placeholder="° max"
            value={this.state.data.overzichtTempMax2}
            onChange={this.handleChange("overzichtTempMax2")}
          />
          <TextInput
            placeholder="° min"
            value={this.state.data.overzichtTempMin2}
            onChange={this.handleChange("overzichtTempMin2")}
          />
          <Select
            options={wind}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Wind"
            value={this.state.data.overzichtWindIcon2}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "overzichtWindIcon2")
            }
          />
          <Select
            options={windSpeed}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Wind Speed"
            value={this.state.data.overzichtWindText2}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "overzichtWindText2")
            }
          />
        </Grid>
        <Grid columns="xsmall" gap="medium" rows="xxsmall">
          <Select
            options={daysShort}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="dag"
            value={this.state.data.overzichtTitle3}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "overzichtTitle3")
            }
          />
          <Select
            options={icons}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Icon"
            labelKey="description"
            valueKey="id"
            value={this.state.data.overzichtIcon3}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "overzichtIcon3")
            }
          />
          <TextInput
            placeholder="° max"
            value={this.state.data.overzichtTempMax3}
            onChange={this.handleChange("overzichtTempMax3")}
          />
          <TextInput
            placeholder="° min"
            value={this.state.data.overzichtTempMin3}
            onChange={this.handleChange("overzichtTempMin3")}
          />
          <Select
            options={wind}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Wind"
            value={this.state.data.overzichtWindIcon3}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "overzichtWindIcon3")
            }
          />
          <Select
            options={windSpeed}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Wind Speed"
            value={this.state.data.overzichtWindText3}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "overzichtWindText3")
            }
          />
        </Grid>
        <Grid columns="xsmall" gap="medium" rows="xxsmall">
          <Select
            options={daysShort}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="dag"
            value={this.state.data.overzichtTitle4}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "overzichtTitle4")
            }
          />
          <Select
            options={icons}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Icon"
            labelKey="description"
            valueKey="id"
            value={this.state.data.overzichtIcon4}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "overzichtIcon4")
            }
          />
          <TextInput
            placeholder="° max"
            value={this.state.data.overzichtTempMax4}
            onChange={this.handleChange("overzichtTempMax4")}
          />
          <TextInput
            placeholder="° min"
            value={this.state.data.overzichtTempMin4}
            onChange={this.handleChange("overzichtTempMin4")}
          />
          <Select
            options={wind}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Wind"
            value={this.state.data.overzichtWindIcon4}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "overzichtWindIcon4")
            }
          />
          <Select
            options={windSpeed}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Wind Speed"
            value={this.state.data.overzichtWindText4}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "overzichtWindText4")
            }
          />
        </Grid>
        <Grid columns="xsmall" gap="medium" rows="xxsmall">
          <Select
            options={daysShort}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="dag"
            value={this.state.data.overzichtTitle5}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "overzichtTitle5")
            }
          />
          <Select
            options={icons}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Icon"
            labelKey="description"
            valueKey="id"
            value={this.state.data.overzichtIcon5}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "overzichtIcon5")
            }
          />
          <TextInput
            placeholder="° max"
            value={this.state.data.overzichtTempMax5}
            onChange={this.handleChange("overzichtTempMax5")}
          />
          <TextInput
            placeholder="° min"
            value={this.state.data.overzichtTempMin5}
            onChange={this.handleChange("overzichtTempMin5")}
          />
          <Select
            options={wind}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Wind"
            value={this.state.data.overzichtWindIcon5}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "overzichtWindIcon5")
            }
          />
          <Select
            options={windSpeed}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Wind Speed"
            value={this.state.data.overzichtWindText5}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "overzichtWindText5")
            }
          />
        </Grid>
        <Grid columns="xsmall" gap="medium" rows="xxsmall">
          <Select
            options={daysShort}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="dag"
            value={this.state.data.overzichtTitle6}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "overzichtTitle6")
            }
          />
          <Select
            options={icons}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Icon"
            labelKey="description"
            valueKey="id"
            value={this.state.data.overzichtIcon6}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "overzichtIcon6")
            }
          />
          <TextInput
            placeholder="° max"
            value={this.state.data.overzichtTempMax6}
            onChange={this.handleChange("overzichtTempMax6")}
          />
          <TextInput
            placeholder="° min"
            value={this.state.data.overzichtTempMin6}
            onChange={this.handleChange("overzichtTempMin6")}
          />
          <Select
            options={wind}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Wind"
            value={this.state.data.overzichtWindIcon6}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "overzichtWindIcon6")
            }
          />
          <Select
            options={windSpeed}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Wind Speed"
            value={this.state.data.overzichtWindText6}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "overzichtWindText6")
            }
          />
        </Grid>
        <Grid
          columns="small"
          justify="end"
          justifyContent="end"
          align="center"
          alignContent="start"
          margin="small"
        >
          <Button
            label="Save data"
            gap="small"
            fill="horizontal"
            plain={false}
            primary={true}
            reverse={true}
            onClick={this.saveDataClick}
          />
          <Text textAlign="start" size="xsmall">
            {this.state.data.lastSaved}
          </Text>
        </Grid>
        <Belgie channel="atv" data={this.state.data} />
      </Main>
    );
  }
}

export default ATV;
